import { BaseInputFilter } from "domain/models/base-input-filter";
import { useJobTitleByFilter } from "presentation/hooks/use-query-job-title";
import { useParameterByFilter } from "presentation/hooks/use-query-parameter";

// import {
//   useCreateClientMutation,
//   useClientsById,
//   useUpdateClientMutation,
// } from "presentation/hooks/use-query-purchase-order";
import { useParameterStore } from "presentation/stores/use-parameter-store";
import { useClientSelectedStore } from "presentation/stores/use-client-selected-store";
import { Button } from "primereact/button";
import { TabPanel, TabView } from "primereact/tabview";
import { Toast } from "primereact/toast";
import { useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./index.css";
import ClientInfoForm from "./ClientInfoForm";
import {
  useClientById,
  useCreateClientMutation,
  useUpdateClientMutation,
} from "presentation/hooks/use-query-client";
import { useTripLocationsByFilter } from "presentation/hooks/use-query-distance";
import { DistanceInputFilter } from "domain/models/distance-input-filter";
import { Parameter } from "domain/entities/parameter";
import { useTripDestinationStore } from "presentation/stores/use-trip-destination-store";

const ClientForm: React.FC = () => {
  const navigate = useNavigate();
  const toast = useRef<Toast>(null);
  const { id } = useParams();

  const { client, setClient, resetClient } = useClientSelectedStore();
  const { tripDestination: tripDestinations, setTripDestination } =
    useTripDestinationStore();
  const { clientType, setClientType } = useParameterStore();

  const {
    mutate: createClientMutation,
    error: creationError,
    isError: isCreationError,
    isSuccess: isCreationSuccess,
    data: clientCreated,
  } = useCreateClientMutation();
  const {
    mutate: updateClientMutation,
    error: updatingError,
    isError: isUpdatingError,
    isSuccess: isUpdatingSuccess,
  } = useUpdateClientMutation();
  const {
    data: tripDestinationData,
    isError: isErrorDestinations,
    isLoading: isLoadingDestinations,
    error: errorDestinations,
    refetch: refetchExistentDestinations,
  } = useTripLocationsByFilter({
    sortBy: "locationDestination",
    sortOrder: "asc",
    page: 1,
    limit: 100,
  } as DistanceInputFilter);

  const { data, isError, isLoading, error } = useClientById(id);

  const { data: parameters } = useParameterByFilter({
    limit: 1000,
    sortBy: "value",
  } as BaseInputFilter);
  const { data: jobTitles } = useJobTitleByFilter({
    limit: 100,
  } as BaseInputFilter);

  useEffect(() => {
    setClientType(
      parameters?.data?.filter((item) => item.type === "clientType")
    );

    // setWorkLocation(
    //   parameters?.data?.filter((item) => item.type === "workLocation-PT")
    // );
  }, [parameters]);

  useEffect(() => {
    if (tripDestinationData?.data) {
      const tripDestinationsMap = new Map<string, Parameter>();

      tripDestinationData.data.forEach((item) => {
        const key = item.locationDestination?.trim();
        if (key && !tripDestinationsMap.has(key)) {
          tripDestinationsMap.set(key, {
            value: item.locationDestination,
            id: item.locationDestination,
            type: "tripDestination",
            createdAt: item.createdAt,
            modifiedAt: item.modifiedAt,
          });
        }
      });
      // tripDestinationsMap.set("Lisboa", {
      //   value: "Lisboa",
      //   id: "Lisboa",
      //   type: "tripDestination",
      //   createdAt: new Date(),
      //   modifiedAt: undefined,
      // });
      const uniqueTripDestinations = Array.from(tripDestinationsMap.values());
      setTripDestination(uniqueTripDestinations);
    }
  }, [tripDestinationData]);

  useEffect(() => {
    if (data && data.data) {
      setClient(data.data);
    } else if (isError) {
      console.error("Erro ao carregar dados do colaborador:", error);
    }
  }, [data, isError, error]);

  const handleNextTab = async () => {
    if (client) {
      !client.id ? createClientMutation(client) : updateClientMutation(client);
    }
  };

  useEffect(() => {
    if (isCreationError || isUpdatingError) {
      // console.log(updatingError);
      let message = [];
      message.push(
        isCreationError ? creationError.message : updatingError.message
      );

      if (
        creationError &&
        creationError.response.data.metadata.errors &&
        creationError.response.data.metadata.errors.length > 0
      ) {
        message = creationError.response.data.metadata.errors;
      } else if (
        updatingError &&
        updatingError.response.data.metadata.errors &&
        updatingError.response.data.metadata.errors.length > 0
      ) {
        message = updatingError.response.data.metadata.errors;
      }
      console.log("message", message);
      message.map((item: string) => {
        toast.current?.show({
          severity: "error",
          summary: "Erro",
          detail: item || "Ocorreu um erro inesperado",
          life: 1500,
        });
      });
    }
  }, [creationError, updatingError]);

  useEffect(() => {
    if (isCreationSuccess || isUpdatingSuccess) {
      const clientId = client?.id || clientCreated?.data?.id;

      if (!clientId) {
        console.error("Erro: clientId está undefined!");
        return;
      }

      const successMessage = isCreationSuccess
        ? "Cliente registrado com sucesso"
        : "Cliente atualizado com sucesso";

      toast.current?.show({
        severity: "success",
        summary: "Sucesso",
        detail: successMessage,
        life: 1500,
      });

      setTimeout(() => {
        resetClient();
        navigate("/clients");
      }, 2000);
    }
  }, [
    isCreationSuccess,
    isUpdatingSuccess,
    resetClient,
    navigate,
    clientCreated,
  ]);

  return (
    <div className="card">
      <TabView>
        <TabPanel header="Cliente" leftIcon="pi pi-address-book mr-2">
          <ClientInfoForm />
        </TabPanel>
      </TabView>
      <div className="next-button default-4-cols ">
        {" "}
        <Button
          label="Guardar"
          onClick={handleNextTab}
          className="button-size"
        />
      </div>
      <Toast ref={toast} position="bottom-right" />
    </div>
  );
};
export default ClientForm;
